//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';
import { INgRedux } from 'ng-redux';

import { CatalogSelectionModalActions } from '@catalog-ingestion/actions/catalogSelectionModalActions';
import { GoogleCatalogIngestionModalActions } from '@catalog-ingestion/actions/googleCatalogIngestionModalActions';
import { CATALOG_INGESTION_TYPES } from '@catalog-ingestion/constants/catalogSelectionConstants';
import welcomeScreenTemplate from '@legacy-components/welcome-screen/welcome-screen.html';
import { navigateToState } from '@react-bridge/wrappers/navigation';
import getUrlParams from '@utils/urlUtils';

import '@legacy-components/welcome-screen/welcome-screen-resource-link';
import '@welcome-page/components/onboarding/OnboardingScreen';

class WelcomeScreen {
  public readonly changeCatalogType: (type: CATALOG_INGESTION_TYPES) => void;
  public readonly openCatalogSelectionModal: () => void;
  public readonly openGoogleCatalogIngestionModal: () => void;
  private readonly unsubscribe: () => void;

  constructor($ngRedux: INgRedux) {
    const actions = Object.assign(
      {},
      CatalogSelectionModalActions,
      GoogleCatalogIngestionModalActions,
    );
    this.unsubscribe = $ngRedux.connect(() => ({}), actions)(this);
  }

  public $onDestroy() {
    this.unsubscribe();
  }

  public $onInit() {
    if (getUrlParams()['open-catalog-selection-modal']) {
      navigateToState('welcome');
      this.changeCatalogType(CATALOG_INGESTION_TYPES.OTHER);
      this.openCatalogSelectionModal();
      this.openGoogleCatalogIngestionModal();
    }
  }
}

angular.module('curalate').component('welcomeScreen', {
  template: welcomeScreenTemplate,
  controller: ['$ngRedux', WelcomeScreen],
});
